import { useState } from "react";
import { Menu, MessageCircle, X } from "lucide-react";
import { businessConfig } from "../content/siteContent";
import { useLanguage } from "./LanguageProvider";
import { track } from "../lib/analytics";
import { BookingLink } from "./ui";

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage();
  return (
    <div className="language-toggle" role="group" aria-label="Choose language / 选择语言">
      <button aria-pressed={language === "en"} onClick={() => setLanguage("en")}>English</button>
      <span aria-hidden="true">|</span>
      <button aria-pressed={language === "zh"} onClick={() => setLanguage("zh")}>中文</button>
    </div>
  );
}

export function SiteHeader() {
  const { copy } = useLanguage();
  const [open, setOpen] = useState(false);
  const links = [
    ["#services", copy.nav.services],
    ["#conditions", copy.nav.conditions],
    ["#about", copy.nav.about],
    ["#reviews", copy.nav.reviews],
    ["#faq", copy.nav.faq],
  ];

  return (
    <header className="site-header">
      <div className="header-inner">
        <a href="#top" className="wordmark" aria-label="Luma Care home" onClick={() => setOpen(false)}>
          <span className="wordmark-mark" aria-hidden="true">L</span>
          <span><strong>Luma</strong> Care</span>
        </a>

        <nav className="desktop-nav" aria-label="Primary navigation">
          {links.map(([href, label]) => <a key={href} href={href}>{label}</a>)}
        </nav>

        <div className="header-actions">
          <a className="desktop-phone" href={`tel:${businessConfig.phoneDigits}`}>{businessConfig.phoneDisplay}</a>
          <LanguageToggle />
          <BookingLink event="hero_booking_click" className="header-book">{copy.nav.book}</BookingLink>
          <button
            className="menu-button"
            aria-label={open ? copy.common.closeMenu : copy.common.openMenu}
            aria-expanded={open}
            aria-controls="mobile-nav"
            onClick={() => setOpen(!open)}
          >
            {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
          </button>
        </div>
      </div>

      <nav id="mobile-nav" className={`mobile-nav ${open ? "is-open" : ""}`} aria-label="Mobile navigation">
        {links.map(([href, label]) => <a key={href} href={href} onClick={() => setOpen(false)}>{label}</a>)}
        <LanguageToggle />
      </nav>
    </header>
  );
}

export function MobileActionBar() {
  const { copy } = useLanguage();
  return (
    <aside className="mobile-action-bar" aria-label="Quick actions">
      <a href={`sms:${businessConfig.phoneDigits}`} onClick={() => track("sms_click")}>
        <MessageCircle size={18} aria-hidden="true" />
        {copy.common.text.replace(` ${businessConfig.phoneDisplay}`, "")}
      </a>
      <a href={businessConfig.bookingUrl} target="_blank" rel="noreferrer" onClick={() => track("hero_booking_click")}>
        {copy.common.book}
      </a>
    </aside>
  );
}
